import React from "react";
import { Route, Routes } from "react-router-dom";
import MiniApp from "./mini-app/mini-app.component";

function UserLoyout() {
  return (
    <>
      <Routes>
        <Route
          path="/*"
          element={<MiniApp />}
        />
      </Routes>
    </>
  );
}

export default UserLoyout;
